import * as yup from 'yup';

yup.setLocale({
  mixed: {
    default: 'Valeur invalide',
    required: 'Ce champ est obligatoire',
    oneOf: 'La valeur doit être l’une des suivantes : ${values}',
    notOneOf: 'La valeur ne doit pas être l’une des suivantes : ${values}',
    defined: 'Ce champ doit être défini',
  },

  string: {
    length: 'Doit contenir exactement ${length} caractères',
    min: 'Doit contenir au moins ${min} caractères',
    max: 'Doit contenir au maximum ${max} caractères',
    matches: 'Le format est invalide',
    email: 'Adresse e-mail invalide',
    url: 'URL invalide',
    uuid: 'UUID invalide',
    trim: 'Ne doit pas contenir d’espaces au début ou à la fin',
    lowercase: 'Doit être en minuscules',
    uppercase: 'Doit être en majuscules',
  },

  number: {
    min: 'La valeur doit être supérieure ou égale à ${min}',
    max: 'La valeur doit être inférieure ou égale à ${max}',
    lessThan: 'La valeur doit être strictement inférieure à ${less}',
    moreThan: 'La valeur doit être strictement supérieure à ${more}',
    positive: 'La valeur doit être positive',
    negative: 'La valeur doit être négative',
    integer: 'La valeur doit être un nombre entier',
  },

  date: {
    min: 'La date doit être postérieure au ${min}',
    max: 'La date doit être antérieure au ${max}',
  },

  array: {
    min: 'Doit contenir au moins ${min} élément(s)',
    max: 'Doit contenir au maximum ${max} élément(s)',
    length: 'Doit contenir exactement ${length} élément(s)',
  },

  object: {
    noUnknown: 'Contient des champs non autorisés',
  },

  boolean: {
    isValue: 'La valeur doit être ${value}',
  },
});
